export default {
  header: {
    themeStyle: '主題風格',
    styles: {
      grayBlue: '灰藍色版',
      blue: '藍色版',
      lightBlue: '湖藍色版',
      green: '綠色版',
      red: '紅色版',
      purple: '紫色版',
      gray: '灰色版'
    },
    welcome: '您好',
    station: 'jeecms主站',
    personal: '個人信息',
    password: '忘記密碼',
    logout: '退出'
  },
  btn: {
    cancel: '取消',
    yes: '是',
    no: '否',
    refresh: '刷新',
    close: '關閉',
    closeOther: '關閉其他',
    closeAll: '關閉所有'
  },
  time: {
    day: '天',
    hour: '小時',
    minute: '分鐘'
  }
}
